import React, { useEffect, useRef, useState } from 'react'
import { AutoComplete, Button, DatePicker, Flex, Form, Input, Modal, notification, Radio, RadioChangeEvent, Select } from 'antd'
import './AddRelative.scss'
import * as  selectOptionsApi from '../../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption, handleDateChangeDayJs } from '../../../until'
import dayjs, { Dayjs } from "dayjs";
import { getListProfession } from '../../../api/profession/professionApi'
import useToast from '../../../hook/useToast'
import { useForm } from 'antd/es/form/Form'
import { set, values } from 'lodash'
import useThrottle from '../../../hook/useThrottle'
import { ICustomerDetail_V2, ICustomerDetail_V4, Item } from '../../../api/customer/customerApi'
import useDebounce from '../../../hook/useDebounce'
import { editBusiness, getInfoBusiness, IBusiness } from '../../../api/business/businessApi'
import { IRelativeBusinessADD } from './AddBusiness'
import { useSelector } from 'react-redux'
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice'

interface Props {
  show: boolean
  infoCustomer?: ICustomerDetail_V4;
  infoBusiness?: IBusiness
  modalClose?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void
}

const UpdateBusiness: React.FC<Props> = (props) => {
  const {
    show, infoCustomer, infoBusiness,
    modalClose, onSubmitFormModal
  } = props

  const formRef: any = useRef(null)
  const [form] = useForm()
  const pushToast = useToast();

  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [sLTaxCodeBusiness, setSLTaxCodeBusiness] = useState<{ value: string }[]>([])
  const [sLBusinessRelationship, setSLBusinessRelationship] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLBusinessField, setSLBusinessField] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProvice, setSLProvice] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLDistrict, setSLDistrict] = useState<selectOptionsApi.ISelectOption[]>([])

  const [isSelectedTaxCode, setIsSelectedTaxCode] = useState(false)

  const [infoRelativeBusinessTmp, setInfoRelativeBusinessTmp] = useState<IRelativeBusinessADD>()


  const gSLTaxCodeBusiness = useDebounce(async (search?: string) => {
    if (!infoCustomer?.id) return
    const result = await selectOptionsApi.getCLTaxCodeBusiness(
      permittedCategoryCarIds,
      infoCustomer?.id, search
    );
    if (result?.status) {
      const filteredOptions = result.data.map(item => ({ value: item.taxCode }));
      setSLTaxCodeBusiness(filteredOptions)
    } else {
      pushToast(result?.message, "error")
    }
  }, 1000)

  const gSBusinessRelationship = async () => {
    const result = await selectOptionsApi.getBusinessRelationship();
    if (result?.status) {
      setSLBusinessRelationship(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const gSLsetSLBusinessField = async () => {
    const result = await selectOptionsApi.getBusinessField();
    if (result?.status) {
      setSLBusinessField(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const gSLProvice = async () => {
    const result = await selectOptionsApi.getListProvince();
    if (result?.status) {
      setSLProvice(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
  }

  const gSLDistrict = useThrottle(async (idChange?: number, id?: number) => {
    const result = await selectOptionsApi.getListDistrict(Number(idChange));
    if (result?.status) {
      setSLDistrict(fommatSelectOption(result.data))
      const item = result.data.find(item => item.id === id)
      if (id && item) {
        form.setFieldValue("quan", { value: item.id, label: item.title })
      }
      else {
        form.setFieldValue("quan", undefined)
      }
    } else {
      pushToast(result?.message, "error")
    }
  }, 500)

  const gInfoBusinessr = async (taxCode: string) => {
    const result = await getInfoBusiness(undefined, taxCode)
    if (result?.status) {
      // setSLDistrict(fommatSelectOption(result.data))
      fomatDataForm(true, result.data)
    } else {
      pushToast(result?.message, "error")
    }
  }



  const fomatDataForm = (isSearch: boolean, infoBusiness: IBusiness | IRelativeBusinessADD) => {
    const {
      address, businessField, businessName, businessRelationship, district, email, foundingDate, phoneBusiness, province, taxCode
    } = infoBusiness
    if (isSearch) {
      setInfoRelativeBusinessTmp({
        address, businessField, businessName, businessRelationship, district, email, foundingDate, phoneBusiness, province, taxCode
      })
      form.setFieldsValue({
        "ma-so-thue": taxCode,
        "ho-ten": businessName,
        "moi-quan-he": { value: businessRelationship?.id, label: businessRelationship?.title },
        "email": email,
        "so-dien-thoai": phoneBusiness,
        "sinh-nhat": dayjs(foundingDate),
        "nghe-nghiep": { value: businessField?.id, label: businessField?.title },
        "thanh-pho": { value: province?.id, label: province?.title },
        "quan": { value: district?.id, label: district?.title },
        "dia-chi": address,
      });

      gSLDistrict(province?.id, district?.id)

      setIsSelectedTaxCode(true)

    } else {

    }
  }

  const onChaneProvice = (value: {
    value: number;
    label: string;
  }) => {
    setSLDistrict([])
    setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, province: { id: value.value, title: value.label } })
    gSLDistrict(value.value)
  }

  const handleSearchTaxCodeBusiness = (value: string) => {
    gSLTaxCodeBusiness(value)
    setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, taxCode: value })

  };

  const handleSelectTaxCodeBusiness = (value: string) => {
    gInfoBusinessr(value)
  };

  const onFormFinish = (values: any) => {
    console.log('values', values)
    return
    const {
      "ma-so-thue": maSoThue,
      "ho-ten": hoTen,
      "moi-quan-he": moiQuanHe,
      email,
      "so-dien-thoai": soDienThoai,
      "sinh-nhat": sinhNhat,
      "nghe-nghiep": ngheNghiep,
      "thanh-pho": thanhPho,
      quan,
      "dia-chi": diaChi,
    } = values;

    confimSubmit(
      maSoThue, hoTen, moiQuanHe?.value, email,
      soDienThoai, handleDateChangeDayJs(sinhNhat), ngheNghiep?.value, thanhPho?.value, quan?.value, diaChi
    )

  }

  const confimSubmit = useThrottle(async (
    taxCode: string, businessName: string, businessRelationshipId: number, email: string,
    phone: string, foundingDate: string, businessFieldId: number, provinceId: number, districtId: number, address: string
  ) => {
    const result = await editBusiness(
      Number(infoBusiness?.id), businessRelationshipId, email, phone, foundingDate,
      businessFieldId, provinceId, districtId, address
    );
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }, 2000)



  useEffect(() => {
    if (show) {
      // if (!sLRelative.length)
      gSLTaxCodeBusiness()
      if (!sLBusinessRelationship.length)
        gSBusinessRelationship()
      if (!sLBusinessField.length)
        gSLsetSLBusinessField()
      if (!sLProvice.length)
        gSLProvice()
    } else {
      form.resetFields()

      setIsSelectedTaxCode(false)
      setSLDistrict([])
      setInfoRelativeBusinessTmp(undefined)
    }
  }, [show])

  useEffect(() => {
    if (infoBusiness && show) {
      setInfoRelativeBusinessTmp(infoBusiness)
      fomatDataForm(true, infoBusiness)


    }
  }, [infoBusiness])

  return (
    <Form
      ref={formRef}
      form={form}
      className='rs-form add-relative-form'
      onFinish={onFormFinish}
    >
      <Modal
        open={show}
        title='Chỉnh sửa doanh nghiệp'
        className='rs-modal w-572 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            loading={false}
            onClick={() => form.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >

        <Form.Item
          layout='vertical'
          label="Mã số thuế"
          name="ma-so-thue"
          rules={[{ required: true, message: 'Vui lòng nhập mã số thuế' }]}
        >
          <AutoComplete

            placeholder="Nhập mã số thuế"
            disabled={isSelectedTaxCode}
            options={sLTaxCodeBusiness} // Danh sách gợi ý
            onSearch={handleSearchTaxCodeBusiness} // Sự kiện tìm kiếm
            onSelect={handleSelectTaxCodeBusiness}
          >
            <Input className="rs-input rs-input--32" />
          </AutoComplete>
        </Form.Item>
        <Form.Item
          layout='vertical'
          label='Tên doanh nghiệp'
          name='ho-ten'
          rules={[
            { required: true, message: "Vui lòng nhập tên doanh nghiệp" }
          ]}
        >
          <Input
            placeholder='Tên doanh nghiệp'
            className='rs-input rs-input--32'
            disabled={isSelectedTaxCode}
            onChange={(e) => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, businessName: e.target.value })}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Mối quan hệ'
          name='moi-quan-he'
          rules={[
            { required: true, message: "Vui lòng chọn mối quan hệ" }
          ]}
        >
          <Select
            placeholder='Mối quan hệ'
            className='rs-select'

            options={sLBusinessRelationship}
            labelInValue
            onChange={e => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, businessRelationship: { id: e.value, title: e.label } })}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Email'
          name='email'
        >
          <Input
            placeholder='Email'
            className='rs-input rs-input--32'
            onChange={e => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, email: e.target.value })}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Số điện thoại'
          name='so-dien-thoai'
          rules={[
            { required: true, message: "Vui lòng nhập số điện thoại" },
            {
              pattern: /^0\d{9}$/,
              message: "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)",
            },
          ]}
        >
          <Input
            placeholder='Số điện thoại'
            className='rs-input rs-input--32'
          // onChange={e => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, phoneBusiness: e.target.value })}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Ngày thành lập'
          name='sinh-nhat'
          rules={[
            { required: true, message: "Vui lòng chọn ngày thành lập" }
          ]}
        >
          <DatePicker
            placeholder='Chọn Ngày thành lập'
            className='rs-date-picker w-full'
            popupClassName='rs-date-picker-dropdown'
            format='DD/MM/YYYY'
            disabledDate={(current) => current && current > dayjs().endOf('day')}
            onChange={e => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, foundingDate: handleDateChangeDayJs(e) })}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Lĩnh vực kinh doanh'
          name='nghe-nghiep'
          rules={[
            { required: true, message: "Vui lòng chọn lĩnh vực kinh doanh" }
          ]}
        >
          <Select
            placeholder='Lĩnh vực kinh doanh'
            className='rs-select'

            options={sLBusinessField}
            labelInValue
            onChange={e => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, businessField: { id: e.value, title: e.label } })}
          />
        </Form.Item>

        <Form.Item
          layout='vertical'
          label='Địa chỉ'
        >
          <Flex vertical className='gap-4px'>
            <Flex className='gap-10px'>
              <Form.Item
                label=''
                name='thanh-pho'
                rules={[
                  { required: true, message: "Vui lòng chọn tỉnh/ thành phố" }
                ]}
                className='w-full'
              >
                <Select
                  placeholder='Chọn tỉnh/thành phố'
                  className='rs-select'

                  options={sLProvice}
                  value={
                    infoRelativeBusinessTmp?.province
                      ? { value: infoRelativeBusinessTmp.province.id, label: infoRelativeBusinessTmp.province.title }
                      : undefined
                  }
                  labelInValue
                  // onChange={(e) => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, province: { id: e.value, title: e.label } })}
                  onChange={(e) => onChaneProvice(e)}
                />
              </Form.Item>

              <Form.Item
                label=''
                name='quan'
                rules={[
                  { required: true, message: "Vui lòng chọn quận/ huyện" }
                ]}
                className='w-full'
              >
                <Select
                  placeholder='Chọn quận/huyện'
                  className='rs-select'

                  options={sLDistrict}
                  value={
                    infoRelativeBusinessTmp?.district
                      ? { value: infoRelativeBusinessTmp.district.id, label: infoRelativeBusinessTmp.district.title }
                      : undefined
                  }
                  labelInValue
                  onChange={(e) => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, district: { id: e.value, title: e.label } })}
                />
              </Form.Item>
            </Flex>

            <Form.Item
              label=''
              name='dia-chi'
            // rules={[
            //   { required: true, message: "Vui lòng nhập địa chỉ" }
            // ]}
            >
              <Input
                placeholder='Địa chỉ'
                className='rs-input rs-input--32'
                onChange={e => setInfoRelativeBusinessTmp({ ...infoRelativeBusinessTmp, address: e.target.value })}
              />
            </Form.Item>
          </Flex>
        </Form.Item>
      </Modal >
    </Form>
  )
}

export default UpdateBusiness
